import { render, staticRenderFns } from "./PriceCheck.vue?vue&type=template&id=48ac26b4"
import script from "./PriceCheck.vue?vue&type=script&lang=js"
export * from "./PriceCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports